/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, October 16th 2021, 7:07:40 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Typography } from "@mui/material";
import { COLORSCHEME } from "theme/styles";
import Stack from "@mui/material/Stack";

export const ErrorTypography = ({ children }) => {
  return (
    <Typography sx={{ color: COLORSCHEME.error }} variant="caption">
      {children}
    </Typography>
  );
};

export const TitleTypography = ({ children }) => {
  return <Typography variant="h5">{children}</Typography>;
};

export const BodyTypography = ({ children }) => {
  return (
    <Typography color="text.secondary" gutterBottom variant="body1">
      {children}
    </Typography>
  );
};

export interface IconTextProps {
  icon: React.ReactNode;
  textComponent: React.ReactNode;
}

export const IconText = ({ icon, textComponent }: IconTextProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      {icon}
      {textComponent}
    </Stack>
  );
};

export const HelperText = ({ children }: { children: React.ReactNode }) => {
  return children ? (
    <div className="os-form-input-help-text">
      {/* <IconText
        icon={<HelpIcon color="primary" />}
        textComponent={<Typography variant="body1">{children}</Typography>}
      /> */}
      <Typography variant="body1">{children}</Typography>
    </div>
  ) : null;
};

export const EmphasisText = ({ children, color = COLORSCHEME.primary, style = {} }) => (
  <span style={{ color, fontWeight: "bold", ...style }}>{children}</span>
);

interface OSMarketingBannerProps {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
}

export const OSMarketingBanner = ({ title, subTitle }: OSMarketingBannerProps) => (
  <>
    <Typography className="os-marketing-banner-title" variant="h4" align="center" color="text.primary" gutterBottom>
      {title}
    </Typography>
    <Typography className="os-marketing-banner-subtitle" variant="h6" align="center" color="text.primary" gutterBottom>
      {subTitle}
    </Typography>
  </>
);
